import { connect } from 'react-redux'
import RemoveFromGroup from './remove-from-group'
import { isOpen, getPupilsIds } from './remove-from-group.selectors'
import { closeRemoveFromGroupDialog } from './remove-from-group.actions'
import { getPupil } from '../../../../../stores/pupils/pupils.selectors'
import { removePupilFromGroup } from '../../../../../stores/pupils/pupils.actions'
import keyBy from 'lodash/keyBy'
import { errorHandler } from 'pobble-components/dist/error-handler'

const mapStateToProps = state => {
  const ids = getPupilsIds(state)
  const includeGroups =
    ids.length === 1 ? keyBy(getPupil(state, ids[0]).groups, 'id') : null
  return {
    title:
      ids.length === 1
        ? 'Remove pupil from a group'
        : `Remove ${ids.length} pupils from a group`,
    ids: ids,
    opened: isOpen(state),
    includeGroups
  }
}

const mapDispatchToProps = dispatch => ({ dispatch })

const mergeProps = (stateProps, { dispatch }, ownProps) => ({
  ...stateProps,
  ...ownProps,
  requestClose: () => dispatch(closeRemoveFromGroupDialog()),
  onSubmit: ({ group }) => {
    stateProps.ids.forEach(id =>
      dispatch(
        removePupilFromGroup({
          student_account_id: id,
          group_id: group
        })
      ).catch(errorHandler)
    )
  }
})

export default connect(
  mapStateToProps,
  mapDispatchToProps,
  mergeProps
)(RemoveFromGroup)
